import React, { PureComponent } from "react";
import { Device } from "@tvg/ts-types/Device";
import { SeoArea } from "@tvg/design-system/web";

export default class SeoFooter extends PureComponent {
  static defaultProps = {
    message: "",
    title: "",
    device: Device.MOBILE,
    addBottomMargin: false
  };

  render() {
    const { title, message } = this.props;
    return title && message && <SeoArea title={title} message={message} />;
  }
}
